import { Box } from "@mui/material";
import type { ReactNode } from "react";

/** Área inferior do card mobile — monta o componente de ações (com modais/estado). */
export function EhrMobileActionsShell({ children }: { children: ReactNode }) {
  if (children == null || children === false) return null;

  return (
    <Box
      sx={{
        width: "100%",
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: (t) => t.palette.action.hover,
        "& .MuiTableCell-root": {
          display: "block",
          borderBottom: "none !important",
          p: 0,
          width: "100%",
        },
      }}
    >
      {children}
    </Box>
  );
}
